import { render, staticRenderFns } from "./LossModal.vue?vue&type=template&id=e50b63b6&scoped=true&"
import script from "./LossModal.vue?vue&type=script&lang=ts&"
export * from "./LossModal.vue?vue&type=script&lang=ts&"
import style0 from "./LossModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LossModal.vue?vue&type=style&index=1&id=e50b63b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50b63b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e50b63b6')) {
      api.createRecord('e50b63b6', component.options)
    } else {
      api.reload('e50b63b6', component.options)
    }
    module.hot.accept("./LossModal.vue?vue&type=template&id=e50b63b6&scoped=true&", function () {
      api.rerender('e50b63b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LossModal/LossModal.vue"
export default component.exports